export default __webpack_public_path__ + "assets/png/2bd04f2af1ead9e674f05afbc4c053c0.png";